import axiosInstance from './axios';

export interface Sede {
    id: string;
    nombre: string;
    direccion?: string | null;
    telefono?: string | null;
    activa: boolean;
    capacidadCarros: number;
    capacidadMotos: number;
    companyId: string;
    createdAt: string;
    usuarios?: number;
    dispositivos?: number;
    espacios?: number;
}

export interface SedeData {
    nombre: string;
    direccion?: string;
    telefono?: string;
    capacidadCarros?: number;
    capacidadMotos?: number;
    activa?: boolean;
    companyId?: string;
}

/**
 * Sedes de la empresa (SUPERADMIN indica companyId)
 */
export const getSedes = async (companyId?: string): Promise<Sede[]> => {
    const response = await axiosInstance.get<Sede[]>('/sedes', { params: { companyId } });
    return response.data;
};

export const createSede = async (data: SedeData): Promise<Sede> => {
    const response = await axiosInstance.post<Sede>('/sedes', data);
    return response.data;
};

export const updateSede = async (id: string, data: Partial<SedeData>): Promise<Sede> => {
    const response = await axiosInstance.put<Sede>(`/sedes/${id}`, data);
    return response.data;
};

export const deleteSede = async (id: string): Promise<{ message: string }> => {
    const response = await axiosInstance.delete<{ message: string }>(`/sedes/${id}`);
    return response.data;
};

export default { getSedes, createSede, updateSede, deleteSede };
